<template>
  <v-app>
    
    <v-app-bar app color="primary" dark>

      <div class="d-flex align-center">
        <v-img
          alt="Trip Kendall"
          class="shrink mr-2"
          contain
          src="https://firebasestorage.googleapis.com/v0/b/huddl3.appspot.com/o/h4ckfu.png?alt=media&token=d1604ed7-2db3-4e9e-be7f-7fa50327eec3"
          transition="scale-transition"
          width="40"
        />

        <v-img
          alt="Whereszup"
          class="shrink mt-1 hidden-sm-and-down"
          contain
          min-width="100"
          src="https://firebasestorage.googleapis.com/v0/b/huddl3.appspot.com/o/JTkTag.png?alt=media&token=d43f77d1-3078-440c-b7a6-ca3aabefee94"
          width="100"
        />
      </div>

      <v-spacer></v-spacer>

      <v-btn href="https:/tripkendall.com" target="_blank" text>
        <span class="mr-2">Hire Me!</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main>
      <HelloWorld/>
    </v-main>
  </v-app>
</template>

<script>
import HelloWorld from './components/HelloWorld';

export default {
  name: 'App',

  components: {
    HelloWorld,
  },

  data: () => ({
    //
  }),
};
</script>

<style scoped>
#app{background-color: #0d73ce!important;}
</style>